import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex items-center" }
const _hoisted_2 = { key: 0 }

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TooltipComponent',
  setup(__props) {

const show = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (show.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (show.value = false)),
      class: "flex items-center justify-center cursor-pointer"
    }, [
      _renderSlot(_ctx.$slots, "trigger")
    ], 32),
    (show.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "tooltip")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})